import { EpimsBaseEntityDto } from "./epim-base.dto";

export class SeisMicSwathDto extends EpimsBaseEntityDto {
    SwathNo: string;
    SwathName: string;
    SwathDescription: string;
    BranchCode: string;
}
    